import React from 'react';
import {NextSeo} from 'next-seo';
import NewsNavDetailsPress from '@components/NewsPress/NewsNavDetailsPress';
import NewsTNHDetails from '@components/NewsTNHDetails/NewsTNHDetails';
import { BookingProvider } from '@contexts/BookingContext';

export default function BaoChiNoiVeTNHDetailsPages(props) {
    const {seoPage} = props;
    
    return (
        <BookingProvider>
            {seoPage && <NextSeo {...seoPage} />}
            <div>
                <NewsNavDetailsPress news={props.preloadedNews} />
                <NewsTNHDetails {...props} />
            </div>
        </BookingProvider>
    );
}
